import { Box } from '@montugroup/design-system';
import { Skeleton } from '@mui/material';

const SKELETON_ROW_COUNT = 8;

export const StocktakeSkeleton = () => {
  return (
    <Box data-testid="stocktake-skeleton">
      <Skeleton width={200} height={42} variant="rounded" sx={{ marginBottom: 6 }} />
      {Array.from({ length: SKELETON_ROW_COUNT }).map((_, i) => (
        <Skeleton key={i} width="100%" height={38} variant="rectangular" sx={{ marginBottom: '0.5rem' }} />
      ))}
    </Box>
  );
};
